import React from 'react'
import LocationSvg from 'images/modules/Shared/i-location.svg?raw'

export { default as LocationUrl } from 'images/modules/Shared/i-location.svg'

export default props => (
  <span role='presentation' {...props} dangerouslySetInnerHTML={{__html: LocationSvg}} />
)
